import * as React from "react"
import { Container, Row, Col } from "react-bootstrap"
import PropTypes from "prop-types"
import HooxBrandmark from "../images/hoox-brandmark.inline.svg"
import SitenuBrandmark from "../images/sitenu-brandmark.inline.svg"
import SendtodeliverBrandmark from "../images/sendtodeliver-brandmark.inline.svg"
import WildeBrandmark from "../images/wilde-brandmark.inline.svg"

const LabelIntroduction = ({ title, subtitle, label }) => {
  function renderLabelBrandmark() {
    switch (label) {
      case "design":
        return <WildeBrandmark />
      case "development":
        return <SitenuBrandmark />
      case "marketing":
        return <SendtodeliverBrandmark />
      case "integrations":
        return <HooxBrandmark />;
      default:
        return;
    }
  }
  return (
    <Container className="component">
      <Row>
        <Col xs={12}>
          <div className="text-center pb-4"><div className="label-brandmark-wrapper">{renderLabelBrandmark()}</div></div>
          <h1 className="text-center">{title}</h1>
        </Col>
        <Col xs={12} md={{ span: 10, offset: 1 }} lg={{ span: 6, offset: 3 }}>
          <p className="bigger text-center">{subtitle}</p>
        </Col>
      </Row>
    </Container>
  )
}

LabelIntroduction.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
}

export default LabelIntroduction
